module.exports = __webpack_public_path__ + "static/img/2.566fab52.png";